import React from 'react';
import './toggle-switch.css';

const ToggleSwitch = ({ isOn, onToggle, disabled }) => {
  return (
    <button
      className={`toggle-switch${isOn ? ' toggle-switch--on' : ''}${disabled ? ' toggle-switch--disabled' : ''}`}
      onClick={() => !disabled && onToggle(!isOn)}
      role="switch"
      aria-checked={isOn}
      disabled={disabled}
      type="button"
    />
  );
};

export default ToggleSwitch;
